export function shuffleInPlace<T>(items: T[], rand: () => number = Math.random): T[] {
  for (let i = items.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1))
    const a = items[i]
    const b = items[j]
    if (a === undefined || b === undefined) continue
    items[i] = b
    items[j] = a
  }
  return items
}

export function shuffled<T>(items: readonly T[], rand: () => number = Math.random): T[] {
  return shuffleInPlace([...items], rand)
}

export function pickIndex(length: number, rand: () => number = Math.random): number {
  if (length <= 0) return 0
  return Math.min(length - 1, Math.floor(rand() * length))
}
